// 세부실행과제 수정 패널(TaskCreatePanel)에 넘길 초기값 — 과제/업무 관리와 핵심 과제 현황이 함께 쓴다

import type { TaskTreeNode } from './components/TaskHierarchyTable'

/** 상세 패널이 넘겨준 세부실행과제 노드로 수정 패널 초기값을 만든다 */
export const buildTaskEditInitialData = (task: TaskTreeNode) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const taskOriginalData = task.originalData as any
  return {
    name: task.origin_name || task.name,
    assigneeId: task.assignee?.id || '',
    assigneeName: task.assignee?.name || '',
    subAssigneeId: task.sub_assignee?.id || '',
    subAssigneeName: task.sub_assignee?.name || '',
    managerId: task.manager?.id || '',
    managerName: task.manager?.name || '',
    reviewerId: task.reviewer?.id || '',
    reviewerName: task.reviewer?.name || '',
    departmentId: taskOriginalData?.department_id || '',
    departmentName: task.department_name || '',
    startAt: taskOriginalData?.start_at || '',
    endAt: taskOriginalData?.end_at || '',
    description: taskOriginalData?.description || '',
    budget: taskOriginalData?.budget ? {
      id: taskOriginalData.budget.id || '',
      resultDescription: taskOriginalData.budget.result_description || '',
      items: taskOriginalData.budget.items?.map((item: any) => ({
        id: item.id,
        name: item.name,
        targetFigure: item.target_figure,
        doneFigure: item.done_figure
      })) || []
    } : undefined,
    performance: taskOriginalData?.performance ? {
      id: taskOriginalData.performance.id || '',
      name: taskOriginalData.performance.name || '',
      unit: taskOriginalData.performance.unit || '',
      items: taskOriginalData.performance.items?.map((item: any) => ({
        id: item.id,
        name: item.name,
        targetFigure: item.target_figure,
        doneFigure: item.done_figure
      })) || []
    } : undefined,
    labels: taskOriginalData?.labels || [],
    detailInfos: taskOriginalData?.detail_infos || [],
    extraInfos: taskOriginalData?.extra_infos || [],
    judgmentBasis: taskOriginalData?.judgment_basis || ''
  }
}
